import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "stepper", 
    "step", 
    "stepContent", 
    "prevButton", 
    "nextButton", 
    "submitButton",
    "progress1",
    "progress2",
    "progress3"
  ]

  connect() {
    this.currentStep = 1
    this.totalSteps = this.stepTargets.length
    this.updateUI()
  }

  nextStep() {
    if (this.currentStep < this.totalSteps) {
      this.currentStep++
      this.updateUI()
    }
  }

  prevStep() {
    if (this.currentStep > 1) {
      this.currentStep--
      this.updateUI()
    }
  }

  updateUI() {
    // Update step indicator circles
    this.stepTargets.forEach((stepElement, index) => {
      const stepNumber = index + 1
      
      if (stepNumber < this.currentStep) {
        // Completed step
        stepElement.classList.remove("bg-gray-300", "text-gray-600", "dark:bg-gray-700", "dark:text-gray-400", "bg-info", "text-white")
        stepElement.classList.add("bg-success", "text-white")
        
        // Update icon to checkmark for completed steps
        stepElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>`
      } 
      else if (stepNumber === this.currentStep) {
        // Current step
        stepElement.classList.remove("bg-gray-300", "text-gray-600", "dark:bg-gray-700", "dark:text-gray-400", "bg-success")
        stepElement.classList.add("bg-info", "text-white")
      }
      else {
        // Future step
        stepElement.classList.remove("bg-info", "text-white", "bg-success")
        stepElement.classList.add("bg-gray-300", "text-gray-600", "dark:bg-gray-700", "dark:text-gray-400")
      }
    })

    // Update progress bars
    if (this.hasProgress1Target) {
      // First progress bar (between steps 1 and 2)
      if (this.currentStep > 1) {
        this.progress1Target.style.width = "100%"
        this.progress1Target.classList.remove("bg-gray-200", "dark:bg-gray-700")
        this.progress1Target.classList.add("bg-success")
      } else {
        this.progress1Target.style.width = "0%"
        this.progress1Target.classList.remove("bg-success")
        this.progress1Target.classList.add("bg-gray-200", "dark:bg-gray-700")
      }
    }
    
    if (this.hasProgress2Target) {
      // Second progress bar (between steps 2 and 3)
      if (this.currentStep > 2) {
        this.progress2Target.style.width = "100%"
        this.progress2Target.classList.remove("bg-gray-200", "dark:bg-gray-700")
        this.progress2Target.classList.add("bg-success")
      } else {
        this.progress2Target.style.width = "0%"
        this.progress2Target.classList.remove("bg-success")
        this.progress2Target.classList.add("bg-gray-200", "dark:bg-gray-700")
      }
    }
    
    if (this.hasProgress3Target) {
      // Third progress bar (between steps 3 and 4)
      if (this.currentStep > 3) {
        this.progress3Target.style.width = "100%"
        this.progress3Target.classList.remove("bg-gray-200", "dark:bg-gray-700")
        this.progress3Target.classList.add("bg-success")
      } else {
        this.progress3Target.style.width = "0%"
        this.progress3Target.classList.remove("bg-success")
        this.progress3Target.classList.add("bg-gray-200", "dark:bg-gray-700")
      }
    }
    
    // Show/hide content based on current step
    this.stepContentTargets.forEach((content, index) => {
      const stepNumber = index + 1
      
      if (stepNumber === this.currentStep) {
        content.classList.remove("hidden")
      } else {
        content.classList.add("hidden")
      }
    })

    // Update navigation buttons
    if (this.currentStep > 1) {
      this.prevButtonTarget.classList.remove("hidden")
    } else {
      this.prevButtonTarget.classList.add("hidden")
    }

    if (this.currentStep === this.totalSteps) {
      this.nextButtonTarget.classList.add("hidden")
      this.submitButtonTarget.classList.remove("hidden")
    } else {
      this.nextButtonTarget.classList.remove("hidden")
      this.submitButtonTarget.classList.add("hidden")
    }
  }
} 
